import { useAuth } from "../../../features/auth/presentation/hooks/useAuth";

/**
 * Returns true if the current user has Admin or CFO role (case-insensitive).
 * Used to exempt these users from closed-month review requirements.
 */
export function useIsAdminOrCFO(): boolean {
  const { user } = useAuth();
  const role = user?.role?.toLowerCase();
  return role === "admin" || role === "cfo";
}
